import _ from 'lodash';
import globalUtils from '../utils/global.util';
import { ProductModel } from './product.model';

export class OrderInfoModel {
    constructor(data) {
        if (!data) data = {};
        this.listProduct = data.listProduct || [];
        this.shipMoney = data.shipMoney || 0;
        this.promotionMoney = data.promotionMoney || 0;
        this.subTotal = this.getSubTotal();
        this.total = this.getTotal();

        this.subTotalStr = globalUtils.formatNumberToPrice(this.subTotal);
        this.totalStr = globalUtils.formatNumberToPrice(this.total);
        this.shipMoneyStr = globalUtils.formatNumberToPrice(this.shipMoney);
        this.promotionMoneyStr = globalUtils.formatNumberToPrice(
            this.promotionMoney
        );
    }
    getSubTotal() {
        if (this.listProduct.length === 0) return 0;
        this.listProduct = this.listProduct.map((o) => new ProductModel(o));
        return _.sumBy(this.listProduct, 'total');
    }
    getTotal() {
        if (this.subTotal === 0) return 0;
        const total = this.subTotal + this.shipMoney - this.promotionMoney;
        if (total <= 0) return 0;
        return total;
    }
}
